'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Typography.css');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/**
 * Modal view component, does not manage its own state.
 */
var Typography = function Typography(_ref) {
  var variant = _ref.variant,
    _ref$align = _ref.align,
    align = _ref$align === undefined ? 'left' : _ref$align,
    color = _ref.color,
    weight = _ref.weight,
    children = _ref.children;
  var typographyClass = (0, _classnames2.default)({
    'c-h1': variant === 'h1'
  }, {
    'c-h2': variant === 'h2'
  }, {
    'c-h3': variant === 'h3'
  }, {
    'c-h4': variant === 'h4'
  }, {
    'u-text-muted': color === 'muted'
  }, {
    'u-text-primary': color === 'primary'
  }, {
    'u-text-success': color === 'success'
  }, {
    'u-text-danger': color === 'danger'
  }, {
    'u-text-strong': color === 'strong'
  }, {
    'u-text-bold': weight === 'bold'
  }, {
    'u-text-center': align === 'center'
  }, {
    'u-text-right': align === 'right'
  });
  switch (variant) {
    case 'h1':
      return _react2.default.createElement('h1', {
        className: typographyClass
      }, children);
    case 'h2':
      return _react2.default.createElement('h2', {
        className: typographyClass
      }, children);
    case 'h3':
      return _react2.default.createElement('h3', {
        className: typographyClass
      }, children);
    case 'h4':
      return _react2.default.createElement('h4', {
        className: typographyClass
      }, children);
    default:
      return _react2.default.createElement('p', {
        className: typographyClass
      }, children);
  }
};
Typography.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Other variants of typography*/
  variant: _propTypes2.default.oneOf(['p', 'h1', 'h2', 'h3', 'h4']),
  /** Where to align the text*/
  align: _propTypes2.default.oneOf(['left', 'center', 'right']),
  /** Color options  for the text */
  color: _propTypes2.default.oneOf(['default', 'muted', 'primary', 'success', 'danger', 'strong']),
  /** Weight of the text*/
  weight: _propTypes2.default.oneOf(['default', 'bold']),
  /** Children of Typography*/
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
} : {};
exports.default = Typography;